import { METHOD_GET, METHOD_POST } from "../../../util/Constants";
import { getBaseSurveysUrl, handleApiResponse } from "./base";

const GET_PENDING_AND_ACTIVE = "/get-pending-and-active";
const POST_SURVEY_RESULTS = "/save-survey-result";

const GET_SURVEY_SHOW_RESULTS = "/get-survey-show-results";

export const fetchPendingAndActiveSurveysApi = async ({ headers, logout }) => {
  const baseSurveysUrl = getBaseSurveysUrl();

  const url = `${baseSurveysUrl}${GET_PENDING_AND_ACTIVE}`;

  const response = await fetch(url, {
    method: METHOD_GET,
    headers: headers,
  });

  return handleApiResponse(response, logout);
};

export const sendSurveyResultApi = async ({
  headers,
  logout,
  body,
  surveyCode,
}) => {
  const baseSurveysUrl = getBaseSurveysUrl();

  const url = `${baseSurveysUrl}${POST_SURVEY_RESULTS}?surveyCode=${surveyCode}`;

  const response = await fetch(url, {
    method: METHOD_POST,
    headers: headers,
    body: JSON.stringify(body),
  });

  return handleApiResponse(response, logout);
};

export const fetchShowSurveyResults = async ({ headers, logout }) => {
  const baseSurveysUrl = getBaseSurveysUrl();

  const url = `${baseSurveysUrl}${GET_SURVEY_SHOW_RESULTS}`;

  const response = await fetch(url, {
    method: METHOD_GET,
    headers: headers,
  });

  return handleApiResponse(response, logout);
};
